<template>
  <nav>
    <div class="row">
      <div class="col-sm-12 col-md-3 text-center mt-2">
          <div v-if="meta_data.exportData" class="row" @click="$emit('ExportResults')" style="margin-left: 0px; align-items: center">
            <a
                        href="#"
                        class="btn btn-round btn-icon btn-sm createNew mt-1"
                        title="Export results"
                      > <i class="fas fa-file-export"></i></a>
          Export Results</div>
      </div>
      <div class="text-center col-sm-12 col-md-7">
        <div>
          <v-row justify="center">
            <v-col cols="10">
              <div class="max-width">
                <v-pagination
                  v-model="meta_data.current_page"
                  :length="meta_data.last_page"
                  :total-visible="7"
                  color="rgb(18, 112, 92)"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @next="next(meta_data.current_page, meta_data.perpage)"
                  @previous="next(meta_data.current_page, meta_data.perpage)"
                  @input="next(meta_data.current_page, meta_data.perpage)"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="col-sm-12 col-md-2 mt-2">
        <div class="dataTables_length" id="datatable_length">
          <label
            >Show rows<select
              name="datatable_length"
              @change="changePerpage(meta_data.current_page, $event)"
              aria-controls="datatable"
              class="custom-select custom-select-sm form-control form-control-sm showRows"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="-1">All</option>
            </select></label
          >
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  props: ["meta_data"],
  data() {
    return {
      maxPages: 3,
    };
  },
  created() {
       
  },
  methods: {
    next(page, perpage) {
      this.$emit("next", page, perpage);
    },
    changePerpage(current, event) {
      current = 1;
      var perpage = event.target.value;
      this.$emit("next", current, perpage);
    },
    ExportResults() {
         
        }
  },
};
</script>
